export default "__VITE_ASSET__DEqoa34___"